export default __webpack_public_path__ + "b31554a3a54b9f6b25fd4895d8580143.png";